import { DatePipe } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import * as moment from 'moment';
import { DatepickerDateCustomClasses } from 'ngx-bootstrap/datepicker';
import { ToastrService } from 'ngx-toastr';
import { DhukanDataService } from 'src/app/services/dhukan/dhukan-data.service';
import { LoginDataService } from 'src/app/services/dhukan/login-data.service';
import { ConfirmationDialogService } from '../../confirmation-dialog/confirmation-dialog.service';
import { ExportgridComponent } from '../../grid/exportgrid/exportgrid.component';
import { Router } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-outletcustomerfootfallreport',
  templateUrl: './outletcustomerfootfallreport.component.html',
  styleUrls: ['./outletcustomerfootfallreport.component.css']
})
export class OutletcustomerfootfallreportComponent implements OnInit {


 
  @ViewChild('filterbar', { static: false }) filterbar;

  isadd: boolean = false;
  isedit: boolean = false;
  isdelete: boolean = false;
  isview: boolean = false;
  isprint: boolean = false;
  isexport: boolean = false;
  isfilter: boolean = false;


  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;


  formname: string = "CustomerReport";


  gridformtype: string = "";

  checkemp: string = "";
  companycheckColl: any = [];
  filterstatus: string = "ALL";
  salesreportColl: any = [];
  dinetypeColl: any = [];
  groupColl: any = [];
  productColl: any = [];
  shiftColl: any = [];


  fromdate: any = new Date();
  todate: any = new Date();
  filterdinetypeid: number = null;
  filtergroupid: number = null;
  filterproductid: number = null;
  filtershiftid: number = null;

  searchtxt: any = "";

  columnDefs = [
    { headerName: 'Outlet', field: 'companyname' },      
   
  ]

  gridOptions = {
    enableactioncol: false,
    columnDefs: this.columnDefs,
  };

  dateCustomClasses: DatepickerDateCustomClasses[];


  rpturl = "https://pivot.reemerp.com";


  videoUrl: any = null;

  pfield:any=null
  constructor(private appService: DhukanDataService, public router: Router, private productFindService: NgbModal, private datePipe: DatePipe,
    private confirmationDialogService: ConfirmationDialogService, private toastr: ToastrService, public loginService: LoginDataService,public domSanitizer: DomSanitizer) {
    this.fnServiceChanges();

    this.dateCustomClasses = [
      { date: new Date(), classes: ['bg-warning'] },
    ];
    //this.fromdate.setDate(this.fromdate.getDate() - 15);
  }

  //Company Check
  fnServiceChanges() {
    this.loginService.serviceloginChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
        if (this.loginService.fnCheckUser()) {
          this.fnCheckPrivilage();
          if (this.isview) {
            this.isloading = true;
            this.fnOnInitForm();
          }
          else {
            this.fnUserFailedForm();
          }
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.loginService.fnCompanyFaildRedirect();
      }
    });
  }


  ngOnInit() {
    try {
      this.videoUrl = this.domSanitizer.bypassSecurityTrustResourceUrl(this.rpturl);
      if (this.loginService.fnCheckCompany()) {
        if (this.loginService.fnCheckUser()) {
          this.fnCheckPrivilage();
          if (this.isview) {
            this.isloading = true;
            this.fnOnInitForm();
          }
          else {
            this.fnUserFailedForm();
          }
        }
        else {
          this.loginService.fnGetUserRoleList();
        }
      }
      else {
        this.loginService.fnCompanyFaildRedirect();
      }
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }
  fnOnInitForm() {
    this.fngetOutletNewCustomerReport();
    // this.fngetDinetype();
    // this.fngetGroup();
    // this.fngetProduct();
    // this.fngetShift();
  }

  fnCheckPrivilage() {

    this.isadd = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE');
    this.isedit = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER');
    this.isdelete = this.loginService.fnCheckUserRoleAction(this.formname, 'DELETE');
    this.isview = this.loginService.fnCheckUserRoleAction(this.formname, 'VIEW');
    this.isprint = this.loginService.fnCheckUserRoleAction(this.formname, 'PRINT');
    this.isexport = this.loginService.fnCheckUserRoleAction(this.formname, 'EXPORT');


  }

  fnUserFailedForm() {
    this.isprivilage = true;
  }



  //Get
  fngetOutletNewCustomerReport() {
    try {
      this.fnShowProgress()
      var data = {
        'organizationid':this.loginService.fnGetOrganizationId(),
        'fromdate': this.fnFormatDatetime(this.fromdate),
        'todate': this.fnFormatDatetime(this.todate),
        'companyid': this.loginService.fnGetCompanyId(),
        'groupid': this.filtergroupid,
      }

      this.appService.getOutletCustomerFootFallReport(data)
        .subscribe(
          (res) => {
            this.fnHideProgress()
            if (res.json().status === 200) {
              this.salesreportColl = res.json().result;

              this.fnAddPivotReport()

            } else if (res.json().status === 400) {
              this.toastr.error("Error", res.json().err_field)
            }
          },
          (err) => {
            this.fnHideProgress()
            this.toastr.error('Error', err);
          })
    } catch (ex) {
      this.fnHideProgress()
      this.fnShowErrorMsg(ex)
    }
  }




  fnAddPivotReport(){
  
    this.fnAddPivotGrid()

  }


  fnAddPivotGrid() {

    var pfield = []

    var pdata:any =null;

    let _datatype = ""
    _datatype = "string"

    pdata = {
      caption: "Outlet",
      area: 'column',
      dataField: "companyname",
      dataType: _datatype,
      groupInterval:null,
      //  format:"cusom"
    }
    pfield.push(pdata)

    
    pdata = {
      caption: "Mode",
      area: 'column',
      dataField: "entrytype",
      dataType: _datatype,
      groupInterval:null,
      //  format:"cusom"
    }


    pfield.push(pdata)
   

    var spdata :any = {
      caption: "Date",
      area: 'row',
      dataField: "salesdate",      
      dataType: "date",
      groupInterval: 'date', 
      format:"dd-MM-yyyy"
    }
    pfield.push(spdata)
    


    let pidata = {
      caption: "Count",
      dataField: "customercount",
      dataType: 'number',
      summaryType: 'sum',
      format: {
        type: 'fixedPoint', precision: 0
      },
      area: 'data',
    }
    pfield.push(pidata)

    // for (let abo of this.columnDefs) {
    //   let pdata = {
    //     caption: this.fnGetCaptionName(abo.field),
    //     area: 'filter',
    //     dataField: abo.field,
    //   }
    //   pfield.push(pdata)
    // }

    console.log(pfield)

    var sdata = {
      fields: pfield,
      store: this.salesreportColl,
    };

    setTimeout(() => {
      this.fnSendMessage(sdata)
    }, 1000)

  }
  
  fnSendMessage(sdata: any) {
    const win = window.frames[0];
    // win.postMessage(message, environment.docViewerURL);
    var data = {
      'MESSAGE': 'PIVOTDATA',
      'SDATA': sdata
    }
    win.postMessage(data, "*");
  }




  fnSetTable() {

  }

  private fnFocusTableRow(index, status) {
    if (index > -1) {
      if (status === 'IN') {
        this.salesreportColl[index].hoverfocus = "IN"
      }
      else {
        this.salesreportColl[index].hoverfocus = ""
      }
    }
  }

  fnTabHeaderClick(type) {
    this.searchtxt = "";
    this.gridformtype = type;
  }

  fnCloseForm() {
    try {
      this.router.navigate(['/Report']);
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnActionExportClick() {
    const modalRef = this.productFindService.open(ExportgridComponent, { size: <any>'xxl', backdrop: 'static' });
    modalRef.componentInstance.doctype = this.formname;
    modalRef.componentInstance.columnDefs = this.columnDefs;
    modalRef.componentInstance.contentColl = this.salesreportColl;
    modalRef.componentInstance.fnSetTable();
    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {


    });
  }



  fnMomentDateTimeFormatter(params) {
    if (params.value) {
      return moment(params.value).format('DD-MM-YYYY hh:mm a');//  
    }
    else {
      return '';
    }

  }
  fnFormatDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        return this.datePipe.transform(dt, "yyyy-MM-dd")
      }

    } else {
      return null
    }

  }
  fnConvertDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        var dateParts = dt.split("-");
        var sdate = new Date(+dateParts[0], dateParts[1] - 1, +dateParts[2] + 1);
        sdate.setMinutes(sdate.getMinutes() + sdate.getTimezoneOffset());
        return sdate;
      }

    } else {
      return null
    }

  }



  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc,
        logby: this.loginService.fnGetModUserId(),
      }


      this.appService.fnInsertActivity(data).subscribe(
        (res) => {
        },
        (err) => {

        });

    } catch {

    }
  }

  private fnShowProgress() {
    this.showProgress = true;
  }
  private fnHideProgress() {
    this.showProgress = false;
  }


  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }















}
